import axios from "axios";

export class GuaranteeSelectionService {

    modifyGuaranteesValues(listaIds) {
        return axios.post('/appapv/modifyGuaranteesValues.action', {}, {
            params: {
                listaIds: listaIds,
            }
        }).then(res => {
            return res.data;
        });
    }
}